import { render, staticRenderFns } from "./MockupSettings.vue?vue&type=template&id=7ac8afde&scoped=true"
import script from "./MockupSettings.vue?vue&type=script&lang=js"
export * from "./MockupSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac8afde",
  null
  
)

export default component.exports